var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.9474657 5.6782201l11.252567.0057555-3.5456673-3.5534783c-.1736245-.1734874-.2688644-.408504-.2688644-.6551687 0-.2466646.0952399-.4800368.2688644-.6539353L9.206072.2694126C9.3795595.0959251 9.6107391 0 9.8572667 0c.2466646 0 .4779812.09524.6514687.2687274l6.0779539 6.0774057c.1741726.1741727.2694126.4061745.2687347.6529762.0006779.248172-.0945621.4803108-.2687347.6542094l-6.0779539 6.0779539C10.3352479 13.904623 10.1040684 14 9.8572667 14c-.2465276 0-.4777072-.095514-.6511947-.2687274l-.5517066-.5519807c-.1736245-.1732134-.2688644-.40453-.2688644-.6511946 0-.2465277.0952399-.4656481.2688644-.6389985l3.5856817-3.5733485H.9348584c-.5079922 0-.934859-.4378297-.934859-.9455478v-.7806936c0-.507718.4394741-.9112888.9474663-.9112888z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.f7f5897c622b2ccb07e3a2f68b14df90.svg";
export { ForwardRef as ReactComponent };